import { createAction, props } from '@ngrx/store';
import { CreateOrderDTO, Order, Payment } from './order.model';
import { HttpErrorResponse } from '@angular/common/http';

export const placeOrder = createAction(
  '[Order API] Create Order',
  props<{ order: CreateOrderDTO | Order }>()
);

export const placeOrderSuccess = createAction(
  '[Order API] Create Order Success',
  props<{ response: Order }>()
);

export const placeOrderFailed = createAction(
  '[Order API] Create Order Failed',
  props<{ err: HttpErrorResponse }>()
);

export const resetPaymentStatus = createAction(
  '[Order State] Reset Payment Status'
);

export const processPayment = createAction(
  '[Order API] Process Payment',
  props<{ orderId: string; payment: Payment }>()
);

export const processSuccess = createAction(
  '[Order API] Process Payment Success',
  props<{ response: Order }>()
);

export const processPaymentFailed = createAction(
  '[Order API] Process Payment Failed',
  props<{ err: HttpErrorResponse }>()
);

// Rehydration
export const rehydrateOrderState = createAction(
  '[App Initialization] Rehydrate Order State',
  props<{ orderState: any }>()
);
